import { subselect } from './root';
import { propertiesSelector } from './properties';
import { PLAYER_STATE_STATUSES } from '../constants';

const isPausedSelector = (playerState) => {
  const { status } = propertiesSelector(playerState);

  return status === PLAYER_STATE_STATUSES.PAUSED;
};

export const playerIsPausedSelector = subselect(isPausedSelector);
